import { BedDouble } from "lucide-react";

/** The stand-in for a stay with no photo yet: a quiet bed mark in the guide's own greys. */
export default function StayPhotoFallback({ label }) {
  return (
    <div className="grid h-full w-full place-items-center bg-[linear-gradient(145deg,#f0efea,#e3e0d8)] dark:bg-[linear-gradient(145deg,#221f1c,#191715)]">
      <span className="flex flex-col items-center gap-1.5 text-[#a8a49c] dark:text-[#6d6963]">
        <BedDouble aria-hidden="true" className="h-6 w-6" strokeWidth={1.6} />
        <span className="font-mono text-[8.5px] font-bold uppercase tracking-[0.2em]">{label}</span>
      </span>
    </div>
  );
}